import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import HomeServices from './components/HomeServices';
import HomeCaseStudy from './components/HomeCaseStudy';
import HomeFAQ from './components/HomeFAQ';
import HomeContact from './components/HomeContact';

export default function HomePage() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <Hero />
      <HomeServices />
      <HomeCaseStudy />
      <HomeFAQ />
      <HomeContact />
      <Footer />
    </main>
  );
}
